// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".plan-modal .ant-input-affix-wrapper {\n  width: 75% !important;\n}\n.plan-modal .ant-form-explain {\n  margin-left: 16.66% !important;\n}\n.plan-modal .ant-modal-footer {\n  text-align: center;\n  border-top: none;\n}", ""]);
// Exports
module.exports = exports;
